export default {
  coordinated: 1,
  cancelled_De: 2,
  cancelled_Prov: 3,
  completed: 4,
  denied: 6,
  extended: 8,
  confirmed: 9,
};
